import clsx from "clsx";
import { useParams } from "react-router-dom";

import { Tooltip } from "@fronterahealth/frontera-ui-components";

import { EmojiButtonInterface } from "@pages/VideoSessionsV2/types";
import { useAdminData } from "@providers/AdminDataProvider";

interface EmojiButtonProps {
  button: EmojiButtonInterface;
  onEmojiClick: (emoji: EmojiButtonInterface) => void;
  disabled?: boolean;
  count: number | null;
}

export const EmojiButton: React.FC<EmojiButtonProps> = ({ button, onEmojiClick, disabled = false }) => {
  const { mediaId } = useParams();
  const { isUserRBT } = useAdminData();

  return (
    <button
      key={button.value}
      onClick={(e?: React.MouseEvent<HTMLElement>) => {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }
        if (isUserRBT && !mediaId) return;
        onEmojiClick(button);
      }}
      disabled={disabled}
      className={`
          flex flex-row items-center
          px-3 py-3 gap-3  max-[640px]:gap-1  my-2
          rounded-full         
          focus:outline-hidden
          ${
            disabled
              ? "bg-gray-50 border border-gray-200 cursor-not-allowed"
              : `
              bg-[#F9F9F9] border border-[#E9E9E9]
              hover:bg-[#EDEAE7] hover:border-green-700
               active:border-green-700
              focus:border-2 focus:border-green-700
            `
          }
        `}
    >
      <Tooltip text={button.text} showInfoIcon={false}>
        <span className={clsx("flex items-center justify-center w-4 h-4", disabled && "opacity-25")}>
          {button.emoji}
        </span>
      </Tooltip>
    </button>
  );
};
